import { SET_USERS_FILTER, SET_USERS_FILTER_ACTIVE, SET_SEARCHBOX_TEXT,
  SELECT_TOOL_USER, VIDEO_SELECT_MEDIA_INDEX, SELECT_VIDEO_TOOL,
  VIDEO_SET_ABSOLUTETIME, SET_ADMIN_CHECK_ACTIVE, SET_VIDEO_STEP } from '../actions/tools';

const initialState = {
  usersFilter: '',
  usersFilterActive: false,
  searchBoxText: '',
  searchBoxDropdown: false,
  selectedUser: undefined,
  selectedGroup: undefined,
  selectedMediaIndex: 0,
  absoluteTime: 0,
  adminCheckActive: false,
  videoToolSelected: false,
  videoStep: 1,
};

function selectMediaIndex(state, action) {
  if (state.selectedMediaIndex !== action.mediaIndex) {
    state.selectedMediaIndex = action.mediaIndex;
    return { ...state };
  }
  return state;
}

function setAbsoluteTime(state, action) {
  if (state.absoluteTime !== action.absoluteTime) {
    state.absoluteTime = action.absoluteTime;
    return { ...state };
  }
  return state;
}

function selectUser(state, action) {
  state.selectedUser = action.user;
  state.selectedGroup = action.group;
  state.searchBoxText = action.user ? action.user.name : '';
  state.searchBoxDropdown = false;
  state.selectedMediaIndex = 0;
  state.absoluteTime = undefined;
  return { ...state };
}

export default function reduceTools(state = initialState, action) {
  switch (action.type) {
    case SET_USERS_FILTER:
      state.usersFilter = action.filter;
      return { ...state };
    case SET_USERS_FILTER_ACTIVE:
      state.usersFilterActive = action.active;
      if (!state.usersFilterActive) {
        state.usersFilter = '';
      }
      return { ...state };
    case SET_SEARCHBOX_TEXT:
      state.searchBoxText = action.text;
      state.searchBoxDropdown = state.searchBoxText.length > 0;
      return { ...state };
    case SELECT_TOOL_USER:
      return selectUser(state, action);
    case VIDEO_SELECT_MEDIA_INDEX:
      return selectMediaIndex(state, action);
    case VIDEO_SET_ABSOLUTETIME:
      selectMediaIndex(state, action);
      return setAbsoluteTime(state, action);
    case SET_ADMIN_CHECK_ACTIVE:
      state.adminCheckActive = action.active;
      return { ...state };
    case SELECT_VIDEO_TOOL:
      state.videoToolSelected = action.selected;
      return { ...state };
    case SET_VIDEO_STEP:
      state.videoStep = action.videoStep;
      return { ...state };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tools.js